import type { CatalogTemplate } from "@nura/contracts";
import { Icon } from "../../shared/ui";

export function creditWord(value: number): string {
  const lastTwo = Math.abs(value) % 100;
  const last = lastTwo % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return "кредитов";
  if (last === 1) return "кредит";
  if (last >= 2 && last <= 4) return "кредита";
  return "кредитов";
}

export function TemplateImage({
  template,
  className = "",
  eager = false,
  full = false,
}: {
  template: CatalogTemplate;
  className?: string;
  eager?: boolean;
  full?: boolean;
}) {
  const source = full ? template.cover.displayUrl : template.cover.previewUrl;
  if (source === "") {
    return (
      <div className={`template-image template-image--empty ${className}`.trim()} role="img" aria-label={`Для образа «${template.name}» пока нет обложки`}>
        <span>{template.name.slice(0, 1).toLocaleUpperCase("ru")}</span>
      </div>
    );
  }
  return (
    <div className={`template-image ${className}`.trim()}>
      <img
        alt={`Пример результата для образа «${template.name}»`}
        decoding="async"
        loading={eager ? "eager" : "lazy"}
        src={source}
      />
    </div>
  );
}

export function TemplateCard({
  template,
  eager = false,
  onSelect,
}: {
  template: CatalogTemplate;
  eager?: boolean;
  onSelect(template: CatalogTemplate): void;
}) {
  return (
    <button
      aria-label={`${template.name}. ${template.description}. ${template.costCredits} ${creditWord(template.costCredits)}`}
      className="template-card"
      data-template-id={template.templateId}
      onClick={() => onSelect(template)}
      type="button"
    >
      <TemplateImage template={template} eager={eager} />
      <span className="template-card__body">
        <strong>{template.name}</strong>
        <span className="template-card__price"><Icon name="coins" size={16} />{template.costCredits}</span>
      </span>
    </button>
  );
}
